import { useEffect, useState } from 'react';
import minus from '../../../../../../assets/media/icons/minus.svg';
import plus from '../../../../../../assets/media/icons/plus.svg';
import { TYPE_BUTTONS } from '../../../../../../constans';
import { Row } from '../../../../../../components/Basic/Blocks';
import { Button } from '../../../../../../components/Basic/Buttons';
import { Icon } from '../../../../../../components/Basic/Elements';
import { Input } from '../../../../../../components/Basic/Inputs';

const ReturnStepper = ({
  item = {},
  skladName,
  entyQuantity = 0,
  order = {},
  save = () => {},
  addToEntry = () => {},
  ...props
}) => {
  const [value, setValue] = useState(0);

  const [showReasonDebit, setShowReasonDebit] = useState(false);

  const onChange = async (v) => {
    await addToEntry(item._id, v).then(() => {
      setValue(0)
    });
  
  };

  const clickAdd = async () => {
    if (value >= 0) {
      onChange(value);
    }
  };

  const clickDebit = async () => {
    if (value > 0) {
      onChange(0 - value); // передаем отрицательное число
    }
    //setShowReasonDebit(false);
  };
  useEffect(() => {
    setValue(item.common_quantity - entyQuantity);
  }, []);

  return (
    <Row>
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginRight: '10px' }}
        disabled={entyQuantity < value}
        onClick={() => clickDebit()}
      >
        <Icon src={minus} width="16px" />
      </Button>
      <Input value={value} onChange={(v) => setValue(v)} style={{ width: '25px' }} center />
      <Button
        type={TYPE_BUTTONS.WHITE}
        style={{ width: '27px', height: '27px', padding: 0, marginLeft: '10px' }}
        onClick={clickAdd}
        disabled={value > item.common_quantity}
      >
        <Icon src={plus} width="15px" />
      </Button>
      {showReasonDebit && (
        <DebitPopUp clickOk={(reason) => clickDebit(reason)} close={() => setShowReasonDebit(false)} />
      )}
    </Row>
  );
};

export default ReturnStepper;
